@use '@/styles/tokens' as *;

.wrap {
  display: flex;
  justify-content: center;
  margin-top: var(--space-6);
}

.pill {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 6px;
  background: var(--surface-inverse);
  border-radius: var(--radius-pill);
  box-shadow: var(--shadow-overlay);
}

.side {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: 12px 18px;
  background: none;
  border: none;
  border-radius: var(--radius-pill);
  color: var(--text-inverse);
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.12s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
}

/* Large lime power button, centered; protrudes slightly above/below the pill. */
.power {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin: -8px var(--space-1);
  border: 4px solid var(--surface-inverse);
  border-radius: var(--radius-pill);
  background: $color-accent1-500;
  color: #111111;
  cursor: pointer;
  transition:
    background 0.12s ease,
    transform 0.1s ease;

  &:hover:not(:disabled) {
    background: $color-accent1-400;
  }

  &:active:not(:disabled) {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(241, 255, 88, 0.6);
  }
}

.powerPending {
  opacity: 0.6;
  cursor: default;
}
